// tw
export default {
  offline_message: '未连线',
  rotate_message: '请把手机转为直向',
  errors: {
    '500': '请稍後再试',
    'offline': '离线状态, 请检查网络连线',
    exceed_daily_order_limit: '抱歉，您已超出本日订单限额。',
    out_of_stock: '此货品暂时售罄。请先从购物篮移除并继续确认订单。',
    not_enough_stock: '库存不够。',
    not_allow_to_checkout: '此商品暂时无法自助购买。请联络美容顾问以购买此商品。请删除此商品以继续前往结账。',
    max_items_reached: '抱歉，每张订单只能购买不多于20件商品。',
    max_qty_reached: '抱歉，每件商品只能购买不多于{{max_qty}}件。'
  },
  labels: {
    exclusive: '独家产品',
    new: 'New',
    limited_edition: '限量产品'
  },
  order_ready: '你的订单 #{{ticket_number}} 已可取货',
  menu_list: {
    home: 'Home',
    all: '所有{{category}}'
  },
  containers: {
    cart: {
      title: '购物篮',
      empty_message: '你的购物篮暂没有货品',
      shop_now: '立即购物',
      subtotal: '合计 ',
      items: {
        one: '(1件产品)',
        other: '({{count}}件产品)'
      },
      place_order_button: '确认订单',
      place_order: '确认下单',
      place_order_message: '是否确认下单？',
      payment_redirect_message: '你将被转到付款页面，请在10分钟内完成付款。',
      pay_at_cashier_message: '请于下单后一小时内前往柜檯付款。',
      yes: '是',
      no: '否',
      dismiss: '返回',
      bag_charge_message: ' 根据香港塑胶购物袋环保徵费计划，每个购物袋将收取 HK${{fee}} 之费用。',
      // staff_code_label: '职员专用', // TODO: i18n
      // staff_code_placeholder: '职员编号', // TODO: i18n
      load_error: '请稍後再试',
      reload_btn: '重新载入',
      deferred_payment: '其它付款方式',
      notice_title: '注意',
      invalid_card: '付款卡无效',
      other_footnote: '如欲以現金或銀聯支付，請前往收銀處付款。以现金或银联支付，请前往柜檯付款。'
    },
    check_in: {
      select_language: '选择语言',
      notice_message: '很抱歉，你必须先办理登入程序方可开始。请向职员出示二维码进场。',
    },
    order_list: {
      title: '你的订单',
      thank_you_title: '感谢你的订购',
      pay_and_collect_message: '请於付款後前往柜檯領取商品。',
      collect_message: '您已成功付款，我们将於準备完成後通知你前往柜檯領取商品',
      order_ready_title: '你的订单已可取货',
      ticket_no_label: '你的取货编号',
      qrcode_message: '取货时请出示此二维码',
      ticket_number: '取货编号: {{ticket_number}}',
      order_state: {
        ready_for_collection: '已可取货',
        in_progress: '仍在处理'
      },
      empty_message: '你还未有任何订单'
    },
    explore: {
      title: '探索',
      browse_all_products: '浏览所有产品',
      search_placeholder: '输入产品名称',
      hint: '提示：输入会场内的快速编码(EXPRESS CODE)',
      tutorial: '观看导览' // TODO: i18n
    },
    product_groups: {
      title: 'Products', // TODO: i18n
      exclusive: '独家产品'
    },
    product_search_result: {
      title: '产品搜寻结果',
      add_to_bag: '加入购物篮',
      added_to_bag: '已加入购物篮',
      continue: '继续',
      out_of_stock: '缺货'
    },
    thank_you: {
      title: '谢谢',
      sorry: '抱歉',
      message: '感谢您使用自助购物服务。',
      wechat_discover_message: '关注香奈儿微信公衆号，探索更多产品资讯。',
      session_expired: 'Session Not Found',
      session_expired_message: '再次下单，请使用自助购物服务。'
    },
    info_form: {
      title: '个人资料',
      register_message: '立刻注册成爲會員，以获取更多专享礼遇。',
      first_name: '名',
      last_name: '姓',
      phone: '手提电话',
      required: '必填',
      accept_pics: '本人希望通过电子邮件、电话、社交媒体、短讯、即时通讯、邮件以及不时获得本人同意的任何其他方式收到上文',
      pics_title: '《收集个人资料声明》',
      pics: '阁下特此代表阁下本人及阁下提供的个人资料所涉及的任何其他人同意Chanel（与我们的母公司及关联公司统称「CHANEL」）将阁下所提供的个人资料（「个人资料」）用於以下目的：销售管控及记录；根据阁下的个人特质、阁下的重要日子及其他个人资料对阁下的CHANEL体验进行个性化；处理产品交付及退货；提供客户服务及处理阁下的查询及投诉；研究及产品开发；以及在阁下同意的前提下，就CHANEL时装及配饰、腕錶及高级珠宝、香水及彩妆进行直接推广。在阁下同意的前提下，CHANEL可能会将个人资料披露或传送予全球CHANEL集团公司及向CHANEL提供与上述用途相关的管理、推广及研究服务的代理商及供应商，或与之共用个人资料。若阁下要求CHANEL不得将个人资料作上述直接推广用途，CHANEL将遵循阁下的要求。如阁下欲提出此等要求，敬请联络客户服务代表。阁下特此同意将个人资料转移至香港以外的地方以作本声明所述的用途或其他直接相关的用途。阁下有权存取、更正或删除个人资料。如阁下希望CHANEL从联络及邮递名单中删除阁下的名字，或希望查询有关个人资料的事宜（包括存取及更正资料），敬请联络CHANEL的客户服务代表，地址为香港中环置地广场告罗士打大厦四十一楼（电邮地址：customerservice@chanel.com.hk）。阁下可於www.chanel.com.hk获得更多关於CHANEL私隐政策的详情。',
      accept_pics_2: '中所述的直接推广资讯。',
      place_order: '提交',
      guest_checkout: '以暱名继续'
    }
  },
  header_menu: {
    menu: '选单',
    search: '搜寻',
    cart: '购物篮',
    my_qr: '二维码'
  },
  searchbar: {
    placeholder: '搜寻', // TODO: i18n
    cancel: '取消',
    reset: '重设'
  },
  shades_list: {
    title: '选择色调'
  },
  sizes_list: {
    title: '选择大小'
  },
  empty_product_search_result: {
    title: `
      很抱歉，找不到与<div class="keyword">「{{keyword}}」</div>相符的产品
    `,
    message: '请试用其他搜寻关键字或输入'
  },
  payment_options_bottom_sheet: {
    select_payment: '选择付款方式'
  }
}



// WEBPACK FOOTER //
// ./src/locales/cn.js